/**
 * Account snippet
 *
 * @author Mautilus s.r.o.
 * @class Snippet_Account
 * @extends Snippet
 */

Snippet_Account = (function(Snippet) {

	var Snippet_Account = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Account.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			this.$lastFocused = null;

			this.$snippetEl = this.$el.find('#snippet-account');
			this.errorField = [];
            this.varTimeout;
			var userName = Storage.get('userName');

		},

		/**
		 * prepare relevant divs for inputs and keyboard
		 *
		 * @private
		 *
		 * @param {Object} jQuery element where should be input
		 * @param {String} placeholder text
		 * @param {Boolean} hidden if true input is password style with *
		 * @returns Input object
		 */
		initInput: function($el, placeholder, hidden){
			var refObj = new Input('font-size: 22px; font-family: Conv_gestareg;',
      {
				placeHolder: placeholder,
				placeHolderFontSize: '22px',
				cursorBorderColor: '#5e5e5e',
				color: '#fff',
				centered: false,
				fontSize: '22px'
			});
			if(hidden){
				refObj.setPasswordMode(); //turn on password mode
			}
			refObj.create($el);
			refObj.blur();
			return refObj;
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-account");
			}
		},

		/**
		 * @inheritdoc Snippet#render
		 */
		render: function() {

			$('#title-email').text(__('email'));
			$('#subtitle-email').text(Storage.get('email'));
			$('#title-name').text(__('name'));
			$('#subtitle-name').text(Storage.get('userName'));
			$('#title-sub').text(__('purchases'));
			$('#title-session').text(__('session'));

			$('#logoutBtn').text(__('sign_out'));
			$('#backBtn').text(__('go_back'));
            symbolFlag = 0;
            Focus.to(this.getFocusable(0));
		},

		clearInputValues: function() {
			this.emailInput.setValue('');
			this.passwordInput.setValue('');
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},

		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {
			var data_action = $el.attr('data-action');
            switch(data_action){
                case 'back':
			        Router.goBack();
                    break;
                case 'logout':
                    API.signOut();
                    break;
            }
			return false;
		},

		addError: function(error) {
			this.errorField.push(error);
		},

		renderError: function(){
			var errorHtml = '<ul id="errors">';
			for(var i = 0, length = this.errorField.length; i < length; i++) {
				errorHtml += '<li class="error">' + __(this.errorField[i]) + '</li>';
			}
			errorHtml += '</ul>';
			this.$errorContainer.html(errorHtml);
		},

		resetHistory: function() {
			console.warn(Router.history);
			Router.history.shift();
			Router.history.shift();
			console.warn(Router.history);
		},

		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction){
			if(direction === 'right'){
				return (! Focus.to(this.getFocusable(1, true)));
			}else if(direction === 'left'){
				return (! Focus.to(this.getFocusable(-1, true)));
			} else if(direction === 'down') {
				this.trigger('focus:out', this, 'down');
			} else if(direction === 'up') {
                this.trigger('focus:out', this, 'up');
            }
			return false;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function($el) {
			if(!$el) {
				$el = this.getFocusable(0);
			}
			return Focus.to($el);
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function($el) {
			this.$lastFocused = $el;
		},

		clear: function() {
			this.$lastFocused = null;
		},
        
		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Snippet
		 *
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		}
	});

	return Snippet_Account;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/account.js
// module id = 59
// module chunks = 0